/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// components

// import PagesDropdown from "../Dropdowns/PagesDropdown.js";
import logo from "../../assets/img/Simranjeet.svg";
import Button from "../Button/Button";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className="top-0 bg-gray-50 shadow-lg fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
        <div className="w-full px-4 lg:px-10 xl:container mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              className="text-white text-sm font-bold leading-relaxed inline-block mr-4  whitespace-no-wrap uppercase"
              to="/"
            >
              <img alt="logo" className="mx-auto w-28" src={logo} />
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="text-white fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col items-center lg:flex-row list-none lg:ml-auto">
              {/* <li className='flex items-center'>
                <Link className='border-transparent border-b-2 hover:border-gray-700 active:border-gray-800 lg:text-white lg:hover:text-gray-800 text-gray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'>
                  Firm
                </Link>
              </li>
              <li className='flex items-center'>
                <Link className='border-transparent border-b-2 hover:border-gray-700 active:border-gray-800 lg:text-white lg:hover:text-gray-800 text-gray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'>
                  Services
                </Link>
              </li>
              <li className='flex items-center'>
                <Link className='border-transparent border-b-2 hover:border-gray-700 active:border-gray-800 lg:text-white lg:hover:text-gray-800 text-gray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'>
                  Location
                </Link>
              </li> */}
              {/* <li className='flex items-center'>
                <PagesDropdown />
              </li> */}
              <li className="flex items-center">
                <a
                  className="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://github.com/thesimranjeet"
                  target="_blank"
                >
                  <i className=" text-blue-900 hover:text-blue-700 transform transition-all hover:scale-125 ease-linear filter-shadow fab fa-github text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Github</span>
                </a>
              </li>

              <li className="flex items-center">
                <a
                  className="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://twitter.com/thesimranjeet"
                  target="_blank"
                >
                  <i className=" text-blue-900 hover:text-blue-700 transform transition-all hover:scale-125 ease-linear filter-shadow fab fa-twitter text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Twitter</span>
                </a>
              </li>

              {/* <li className="flex items-center">
                <a
                  className="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://instagram.com/"
                  target="_blank"
                >
                  <i className=" text-gray-700 hover:text-gray-800 transform transition-all hover:scale-125 ease-linear hover:filter-shadow fab fa-instagram text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Star</span>
                </a>
              </li> */}

              <li className="flex items-center ml-3 mb-3 lg:mb-0">
                {/* <button
                  className="text-gray-50 bg-gray-700 hover:bg-gray-800 active:bg-gray-900 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                  type="button"
                >
                  Call Us <i className="fas fa-phone ml-2"></i>
                </button> */}
                <Button to="https://linktr.ee/thesimranjeet">
                  Resume <i className="fas fa-arrow-alt-circle-down"></i>
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
